/* Struxa: the bulk discount quantity and percentage live in theme settings
   (Theme editor -> Struxa bulk discount) and reach this file through
   window.SX_BULK, which layout/theme.liquid emits in <head>. Do not retype
   the numbers below - change the setting. Note the real discount is a
   separate automatic discount in Shopify; keep the two matching.
   TO REVERT: delete these two lines and hardcode 10 again. */
var SX_BULK_QTY = (window.SX_BULK && window.SX_BULK.qty) || 10;
var SX_BULK_PCT = (window.SX_BULK && window.SX_BULK.percent) || 10;

(function(){
  var R2 = 'https://pub-38cb3bf26b2c46dbb6eb7d17f61c0227.r2.dev';
  var END_FITTING_VARIANTS = window.GSC_DATA.endFittingVariants;
  var BRACKET_VARIANTS = window.GSC_DATA.bracketVariants || {};
  var END_FITTING_URLS = window.GSC_DATA.endFittingUrls || {};
  var BRACKET_URLS = window.GSC_DATA.bracketUrls || {};
  function addFittingToCart(variantId, qty, ballStud, btn, msgEl, extraProps, onSuccess){
    var base = msgEl.className;
    if(!variantId){
      msgEl.textContent = 'This item is not available to order online yet - please contact us.';
      msgEl.className = base + ' show error';
      return;
    }
    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Adding…';
    var item = { id: variantId, quantity: qty };
    var props = {};
    if(ballStud !== null){
      props['Ball Stud'] = ballStud ? 'Yes' : 'No';
    }
    if(extraProps){
      for(var pk in extraProps){ if(extraProps.hasOwnProperty(pk)) props[pk] = extraProps[pk]; }
    }
    if(Object.keys(props).length){ item.properties = props; }
    var cartDrawerEl = document.querySelector('cart-drawer');
    var reqBody = { items: [item] };
    if(cartDrawerEl){
      reqBody.sections = 'cart-drawer,cart-icon-bubble';
      reqBody.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(reqBody)
    }).then(function(res){
      if(!res.ok){ return res.json().then(function(d){ throw new Error(d.description || 'Could not add to cart'); }); }
      return res.json();
    }).then(function(data){
      /* "View cart" used to be a hard link to /cart. On the ordinary catalogue
         page that was merely a page load; inside the Trade Portal it threw the
         customer out of the portal entirely (board row P-04). The drawer is
         already open at this point - renderContents runs just below - so this
         now focuses that drawer instead. Falls back to the /cart href whenever
         there is no drawer, so nothing is lost if cart_type is ever 'page'. */
      msgEl.innerHTML = 'Added to cart - <a href="/cart" data-gsc-viewcart>View cart</a>';
      msgEl.className = base + ' show';
      if(cartDrawerEl && data && data.sections){
        cartDrawerEl.renderContents(data);
      }
      if(typeof onSuccess === 'function'){ onSuccess(data); }
    }).catch(function(err){
      msgEl.textContent = err.message || 'Something went wrong adding this to your cart.';
      msgEl.className = base + ' show error';
    }).finally(function(){
      btn.disabled = false;
      btn.textContent = origText;
    });
  }
  function r2img(name){ return R2 + '/' + encodeURIComponent(name) + '.png'; }
  /* 8mm is stocked and sells off the grid above. 10mm is request-only:
     it has no cards, no variants and no inventory - it exists solely as
     an option on the Need a Different Length form, $88 incl GST each. */
  var PRICES = { 8: 75, 10: 88 };
  var SHAFT_LETTER = { 6:'A', 8:'B', 10:'C', 12:'D' };

  // Trade-tier customers get an automatic checkout discount (10/15/18/22% depending
  // on tier), but the card price shown here was always the full retail price since
  // Shopify's automatic discounts don't affect collection-page pricing on their own.
  // GSC_DATA.tradeDiscountPct is computed server-side (Liquid) from the same
  // tier logic as the account Trade Status tab, so this mirrors the real checkout price.
  /* Struxa: window.SX_TRADE (layout/theme.liquid) reads the tier TAG that
     Shopify Flow sets, which is the same thing the automatic discount keys
     off. GSC_DATA.tradeDiscountPct re-counts orders in Liquid on this page
     only and can disagree with it. Prefer the tag; keep the old value as a
     fallback so nothing breaks if the head block is ever removed. */
  var TRADE_PCT = (window.SX_TRADE && +window.SX_TRADE.pct) ||
                  (window.GSC_DATA && window.GSC_DATA.tradeDiscountPct) || 0;
  function priceNode(basePrice){
    var wrap = document.createElement('div');
    if(TRADE_PCT > 0){
      wrap.classList.add('gsc-price-trade');
      var discounted = basePrice * (1 - TRADE_PCT / 100);
      var was = document.createElement('span');
      was.className = 'gsc-price-was';
      was.textContent = '$' + basePrice.toFixed(2);
      var now = document.createElement('span');
      now.className = 'gsc-price-now';
      now.textContent = '$' + discounted.toFixed(2);
      var tag = document.createElement('span');
      tag.className = 'gsc-price-tag';
      var pctLabel = (TRADE_PCT % 1 === 0) ? TRADE_PCT.toFixed(0) : TRADE_PCT.toFixed(1);
      tag.textContent = pctLabel + '% off · Trade price';
      wrap.appendChild(was);
      wrap.appendChild(now);
      wrap.appendChild(tag);
    } else {
      wrap.textContent = '$' + basePrice.toFixed(2);
    }
    return wrap;
  }

  // Live stock - rendered fresh from the "8mm Gas Strut" product's variants on every
  // page load, so this always matches whatever quantities are set in Shopify admin.
  var STRUT_SIZES = window.GSC_DATA.strutSizes;

  var BUCKET_TUBE = {
    h6:     'Standard plastic 10mm socket tube',
    h2a:    'Angled plastic socket 10mm tube',
    f6sp:   'Small plastic socket 10mm tube',
    f7:     'Metal Socket 10mm tube',
    thread: '8mm thread tube',
    eye:    '8mm metal eye tube'
  };
  var BUCKET_SHAFT = {
    h6:     'Standard plastic 10mm socket shaft',
    h2a:    'Angled plastic socket 10mm shaft',
    f6sp:   'Small plastic socket 10mm shaft',
    f7:     'Metal socket 10mm shaft',
    thread: '8mm thread shaft',
    eye:    '8mm metal eye shaft'
  };
  // Ball-stud variants of the composite renders above (same combos, with a ball stud added to that end).
  var BUCKET_SHAFT_BALL = {
    h6:     'Standard plastic socket 10mm shaft ball stud',
    h2a:    'Angled plastic socket 10mm shaft ball stud',
    f6sp:   'Small plastic socket 10mm ball stud shaft',
    f7:     'Metal socket 10mm ball stud shaft'
  };
  var BUCKET_TUBE_BALL = {
    h6:     'Standard plastic socket 10mm tube ball stud',
    h2a:    'Angled plastic socket 10mm tube ball stud',
    f6sp:   'Small plastic socket 10mm ball stud tube',
    f7:     'Metal socket 10mm ball stud tube'
  };

  // Standalone fitting product shots (rotated + cropped renders), used only in the End Fittings info grid.
  var FIT_STANDALONE_IMG = {
    h6:   'fitting-h6.png',
    h2a:  'fitting-h2a.png',
    f6sp: 'fitting-f6sp.png',
    f7:   'fitting-f7.png',
    eye:  'fitting-eye.png'
  };
  var FIT_STANDALONE_IMG_BALL = {
    h6:   'fitting-h6-ballstud.png',
    h2a:  'fitting-h2a-ballstud.png',
    f6sp: 'fitting-f6sp-ballstud.png',
    f7:   'fitting-f7-ballstud.png'
  };

  // Fitting codes confirmed against Struxa's official gas strut code sheet.
  // code = base fitting code, ballCode = code when a CT2 ball stud is added.
  // f7 and thread have no confirmed code in the sheet yet, shown as "TBC".
  /* Struxa: "Fits 10mm ball stud" assumed the customer already knew what a ball
     stud is. Most do not - they are looking at an old strut and a car. These say
     what the fitting DOES, and BALL_STUD_NOTE below explains the part itself.
     "Threaded End" is now "M8 Thread", which is what it is called on the bench. */
  var FIT_OPTIONS = [
    { id:'h6',     code:'1', ballCode:'1A', name:'Standard Plastic Socket 10mm', desc:'Nylon socket · clips onto a 10mm ball stud', studCompatible:true },
    { id:'h2a',    code:'2', ballCode:'2A', name:'Angled Plastic Socket 10mm',   desc:'Nylon, angled · clips onto a 10mm ball stud', studCompatible:true },
    { id:'f6sp',   code:'3', ballCode:'3A', name:'Small Plastic Socket 10mm',    desc:'Nylon, compact · clips onto a 10mm ball stud', studCompatible:true },
    { id:'f7',     code:'4', ballCode:'4A', name:'Metal Ball Socket 10mm',       desc:'Steel socket · clips onto a 10mm ball stud', studCompatible:true },
    /* Struxa: M8 Thread is withdrawn as a CHOICE (Dave, 2026-09-01) - it is a
       bare thread rather than a fitting, and nothing we hold is built with it.
       The row itself stays so FIT_MAP still resolves it and an older code with
       a '0' segment keeps its name; `hidden` is what keeps it out of every
       select. Delete the flag to put the option back. Metal Eye End M8 (EF5)
       is a different part and stays selectable. */
    { id:'thread', code:'0', ballCode:null, name:'M8 Thread',                    desc:'Bare M8 thread · screws into your own fitting, no socket', studCompatible:false, hidden:true },
    { id:'eye',    code:'5', ballCode:null, name:'Metal Eye End M8',             desc:'Steel eye, 8mm pin hole · bolts through, no ball stud', studCompatible:false }
  ];
  /* What a customer can actually pick. FIT_OPTIONS stays the full code table;
     this is the subset every <select> is built from. */
  var FIT_CHOICES = FIT_OPTIONS.filter(function(f){ return !f.hidden; });
  /* Shown once beside the end-fitting selects. This is the sentence customers
     actually need; everything else is detail. */
  var BALL_STUD_NOTE = 'A ball stud is the 10mm ball-shaped pin bolted to the vehicle. The socket clips over it - if your old strut pops off a little ball, that is what you have.';
  var FIT_MAP = {};
  FIT_OPTIONS.forEach(function(f){ FIT_MAP[f.id] = f; });

  /* Struxa: one description element per select, inserted straight after it and
     kept in step with the selection. Built in JS rather than in the Liquid so
     the markup and the option list cannot drift apart. Idempotent - calling it
     twice on the same select is a no-op. */
  function attachFitDesc(select){
    if(!select || select.__sxDesc) return;
    var d = document.createElement('div');
    d.className = 'gsc-fit-desc';
    d.style.cssText = 'margin:4px 0 0;font-size:12px;line-height:1.45;color:#55555a;';
    select.parentNode.insertBefore(d, select.nextSibling);
    function paint(){
      var f = FIT_MAP[select.value];
      if(!f){ d.textContent = ''; return; }
      d.textContent = f.desc;
      if(f.studCompatible) d.title = BALL_STUD_NOTE;
    }
    select.addEventListener('change', paint);
    select.__sxDesc = d;
    paint();
  }

  /* Struxa: the ball-stud sentence itself, shown once per modal rather than
     repeated under both selects. Guarded by id so re-opening the modal does not
     stack copies. */
  function attachStudNote(afterSelect, id){
    if(!afterSelect || document.getElementById(id)) return;
    var anchor = afterSelect.__sxDesc || afterSelect;
    var n = document.createElement('p');
    n.id = id;
    n.className = 'gsc-studnote';
    n.style.cssText = 'margin:10px 0 0;padding:8px 10px;background:#f6f6f4;border-left:2px solid #ff7a00;font-size:12px;line-height:1.5;color:#55555a;';
    n.textContent = BALL_STUD_NOTE;
    anchor.parentNode.insertBefore(n, anchor.nextSibling);
  }

  // End Fittings info panel: all 5 selectable fittings, including Metal Eye End (M8).
  var END_FITTINGS_INFO = [
    { id:'h6',     name:'Standard Plastic Socket 10mm', code:'1',  ballCode:'1A', desc:'Nylon · fits both shaft end and body/tube end · M8 thread', studCompatible:true,  img:true },
    { id:'h2a',    name:'Angled Plastic Socket 10mm',   code:'2',  ballCode:'2A', desc:'Nylon, angled body · fits both shaft end and body/tube end · M8 thread', studCompatible:true,  img:true },
    { id:'f6sp',   name:'Small Plastic Socket 10mm',    code:'3',  ballCode:'3A', desc:'Nylon, compact · fits both shaft end and body/tube end · M8 thread', studCompatible:true,  img:true },
    { id:'f7',     name:'Metal Ball Socket 10mm',       code:'4',  ballCode:'4A', desc:'Steel · fits both shaft end and body/tube end · M8 thread', studCompatible:true, img:true },
    { id:'eye',    name:'Metal Eye End M8',              code:'5',  ballCode:null, desc:'Steel eye end, 8mm pin hole · fits both shaft end and body/tube end · M8 thread', studCompatible:false, img:true },
    /* Struxa: the threaded end was selectable but missing from this panel, so
       the only fitting with no picture was also the only one with no entry.
       It is now withdrawn instead (see FIT_OPTIONS above): `hidden` keeps its
       card out of the End Fittings panel while parseProductCode() below can
       still read a '0' segment off an older code. Delete the flag to show it
       again. */
    { id:'thread', name:'M8 Thread',                     code:'0',  ballCode:null, desc:'Bare M8 thread, no socket · for screwing into your own fitting · fits both shaft end and body/tube end', studCompatible:false, img:false, hidden:true }
  ];

  // Mounting brackets - flat plate and offset (ball stud on the outer face), both with a fixed
  // 10mm ball stud (no shaft/tube fitting selection, no ball-stud toggle - the stud is part of
  // the bracket itself).
  var BRACKETS_INFO = [
    { id:'flat',   name:'Flat Bracket, 10mm Ball Stud',    desc:'2mm steel plate · three 5mm mounting holes · 10mm ball stud · includes 3x silver steel countersunk self-tapping screws', price:10, img:'https://cdn.shopify.com/s/files/1/0776/7477/4628/files/bracket-flat-10mm-ball-stud-v2.jpg' },
    { id:'lshape', name:'Offset Bracket, 10mm Ball Stud', desc:'2.8mm steel plate · five 5mm mounting holes · ball stud on outer face · includes 5x silver steel countersunk self-tapping screws', price:10, img:'https://cdn.shopify.com/s/files/1/0776/7477/4628/files/bracket-l-shape-10mm-ball-stud-v2.jpg' }
  ];

  var DEFAULT_FIT = 'h6';
  /* 650N is the top of what Struxa can supply on an 8mm shaft. Above that is
   10mm shaft, which is barely stocked - Dave, 14/09/2026. The slider used to
   run to 750, so the page was quoting a force we cannot fill and the
   configurator would happily build a product code for it. */
  var FORCE_MIN = 100, FORCE_MAX = 650, FORCE_STEP = 10, FORCE_DEFAULT = 300;
  /* The bounds the request form will accept. 8mm mirrors what is stocked;
     10mm is request-only, so this is the span we are willing to quote on. */
  var LENGTH_RANGE = { 8: { min: 250, max: 700 }, 10: { min: 250, max: 900 } };
  var FORCE_MIN = 100, FORCE_MAX = 650;   // same span as the slider above

  // per-card runtime state, indexed same as STRUT_SIZES
  var STATE = STRUT_SIZES.map(function(){
    return { shaftFit: DEFAULT_FIT, bodyFit: DEFAULT_FIT, shaftBall: false, bodyBall: false, qty: 1, force: FORCE_DEFAULT };
  });

  var modalIdx = null;
  var bulkIdx = null;

  function fitName(id){
    var f = FIT_MAP[id];
    return f ? f.name : id;
  }

  /* Struxa: every share icon on this page did the same two things wrong.
     (1) The orange "copied" state only appeared once copyShareUrl() resolved,
     and copyShareUrl waits on the /apps/rewards/me referral lookup before it
     even reaches the clipboard - so the icon sat unchanged for a second or two
     after a click that had already worked. It is painted FIRST now and only
     walked back if the copy really fails.
     (2) On a phone there was no native share sheet. navigator.share needs
     transient user activation, so it must be called synchronously inside the
     click - nothing may be awaited before it or iOS rejects the call. That is
     why the referral code is warmed once up front and read from a cache here
     instead of being looked up at share time; a share fired before the lookup
     lands goes out as a plain link, which is what it was before referral codes
     existed. An AbortError is the customer closing the sheet, not a failure. */
  var SHARE_REF_CODE = null;
  function warmShareRefCode(){
    if(SHARE_REF_CODE !== null) return;
    SHARE_REF_CODE = '';
    if(!(window.StruxaShare && window.StruxaShare.getOwnReferralCode)) return;
    window.StruxaShare.getOwnReferralCode().then(function(c){ SHARE_REF_CODE = c || ''; }, function(){ SHARE_REF_CODE = ''; });
  }
  function refShareUrl(url){
    if(!SHARE_REF_CODE || window.SX_REF_SHARE_OPTOUT) return url;
    if(!(window.StruxaShare && window.StruxaShare.withReferralCode)) return url;
    return window.StruxaShare.withReferralCode(url, SHARE_REF_CODE);
  }
  function shareLink(btn, url, title, restTitle){
    if(btn.__gscOrigColor === undefined) btn.__gscOrigColor = btn.style.color;
    function mark(ok){
      btn.style.color = ok ? '#ff7a00' : '#c0392b';
      btn.title = ok ? 'Link copied!' : 'Could not copy - try again';
      if(btn.__gscShareT) clearTimeout(btn.__gscShareT);
      btn.__gscShareT = setTimeout(function(){ btn.style.color = btn.__gscOrigColor; btn.title = restTitle; }, 1500);
    }
    function copyFallback(){
      mark(true);
      window.StruxaShare.copyToClipboard(refShareUrl(url)).catch(function(){ mark(false); });
    }
    // No "Link copied!" on the native path - the share sheet is the feedback.
    if(navigator.share){
      try {
        var res = navigator.share({ title: title, text: 'From Struxa: ' + title, url: refShareUrl(url) });
        if(res && res.then){ res.then(null, function(err){ if(err && err.name === 'AbortError') return; copyFallback(); }); }
        return;
      } catch(e){}
    }
    copyFallback();
  }

  // Builds a customer-facing fitting label. When shaft and body ends match, returns
  // the single fitting name. When they differ (custom build), names BOTH ends instead
  // of collapsing to a vague "Custom (see order notes)" string that hid the actual
  // selections from cart/checkout/order-confirmation line items.
  function buildFitLabel(shaftFitId, shaftBall, bodyFitId, bodyBall){
    if(shaftFitId === bodyFitId && shaftBall === bodyBall){
      var fo = FIT_MAP[shaftFitId];
      /* " (both ends)" matches the dropdown the customer actually chose from -
         the option text carries that suffix and this label used to drop it, so
         the cart, the checkout, the confirmation email and the tax invoice all
         described a two-ended part with one unqualified name. */
      return (fo ? fo.name : shaftFitId) + (shaftBall ? ' + ball stud' : '') + ' (both ends)';
    }
    return 'Shaft end: ' + fitName(shaftFitId) + (shaftBall ? ' + ball stud' : '') +
      ' / Body end: ' + fitName(bodyFitId) + (bodyBall ? ' + ball stud' : '');
  }

  function compositeUrl(shaftFitId, bodyFitId, shaftBall, bodyBall){
    var shaftName = (shaftBall && BUCKET_SHAFT_BALL[shaftFitId]) ? BUCKET_SHAFT_BALL[shaftFitId] : BUCKET_SHAFT[shaftFitId];
    var tubeName  = (bodyBall && BUCKET_TUBE_BALL[bodyFitId]) ? BUCKET_TUBE_BALL[bodyFitId] : BUCKET_TUBE[bodyFitId];
    return R2 + '/' + encodeURIComponent(shaftName) + '__' + encodeURIComponent(tubeName) + '.png';
  }

  var BULK_DISCOUNT_QTY = SX_BULK_QTY;
  var BULK_DISCOUNT_RATE = (SX_BULK_PCT / 100);

  /* Struxa: trade and bulk are both automatic discounts in Shopify, and
     Shopify applies only the single best one - so this line has to show the
     best of the two, not bulk alone. It used to ignore TRADE_PCT entirely,
     which is why a trade customer saw their price on the card and retail on
     this line. TO REVERT: drop bestPct/bestWhy and use BULK_DISCOUNT_RATE. */
  function priceLineHtml(diam, qty){
    var unitPrice = PRICES[diam];
    if(!unitPrice) return '';
    qty = Math.max(1, qty || 1);
    var isBulk = qty >= BULK_DISCOUNT_QTY;
    var bulkPct = isBulk ? SX_BULK_PCT : 0;
    var bestPct = Math.max(TRADE_PCT, bulkPct);
    var bestWhy = (TRADE_PCT >= bulkPct) ? 'trade discount' : 'bulk discount';
    /* Struxa: Elite is the one tier where bulk stacks, via a separate automatic
       discount in Shopify ("Elite Bulk Discount - 10+ Gas Struts", 25%, min qty
       10, Tier: Elite). Mirror it here or the page understates the price. */
    if (isBulk && window.SX_TRADE && window.SX_TRADE.elite) {
      bestPct = TRADE_PCT + 5;
      bestWhy = 'Elite bulk discount';
    }
    var line = '$' + unitPrice.toFixed(2) + ' per ' + diam + 'mm strut (incl. GST)';
    if(qty > 1){
      var subtotal = unitPrice * qty;
      if(bestPct > 0){
        var discounted = subtotal * (1 - bestPct / 100);
        line += ' &middot; <strong>' + qty + '</strong> struts &middot; <s style="color:#1c1e22;">$' + subtotal.toFixed(2) + '</s> total <strong>$' + discounted.toFixed(2) + '</strong> <span style="color:#1c7a1c;font-weight:700;">(' + bestPct + '% ' + bestWhy + ' applied)</span>';
      } else {
        line += ' &middot; <strong>' + qty + '</strong> struts &middot; total <strong>$' + subtotal.toFixed(2) + '</strong>';
      }
    }
    return line;
  }

  function forceToLbs(n){ return Math.round(n * 0.2248); }
  function forceToKg(n){ return Math.round(n / 10); }

  function fitCode(id, hasBall){
    var f = FIT_MAP[id];
    if(!f || !f.code) return null;
    if(hasBall && f.studCompatible && f.ballCode) return f.ballCode;
    return f.code;
  }

  /* THE NAME A CUSTOMER SEES ON THEIR CART LINE AND IN THEIR EMAIL.

     It used to read "8mm x 440mm x 400N Gas Strut", which leads on the shaft
     diameter with no label - the same ambiguity Dave objected to in the
     product title on 10/09/2026, where "8mm Gas Strut" scans as a strut 8mm
     long. Every other number on the page is millimetres of LENGTH, so the one
     that is not needs saying so.

     Matches the Shopify product title, "Gas Strut - 8mm Shaft", deliberately:
     a plain hyphen, never an em dash, and each number labelled.

     FIVE PLACES BUILT THIS STRING INDEPENDENTLY across three files - here
     three times, plus shared-build-editor.js and sx-label-scanner.liquid.
     Theme assets have no shared module, so they cannot be one function; they
     can at least be one SHAPE, and tools/cart-props.test.js reads the sources
     and fails if any of them drifts. */
  function fullStrutName(diam, len, force){
    return 'Gas Strut - ' + diam + 'mm Shaft, ' + len + 'mm, ' + force + 'N';
  }

  function buildProductCode(diam, len, force, shaftFitId, shaftBall, bodyFitId, bodyBall){
    var letter = SHAFT_LETTER[diam] || '?';
    var base = letter + '-' + len + '-' + Math.round(force / 10);
    var sCode = fitCode(shaftFitId, shaftBall);
    var bCode = fitCode(bodyFitId, bodyBall);
    if(!sCode || !bCode) return null;
    return base + '-' + sCode + '-' + bCode;
  }

  /* A mixed pair of ends matches no <option>, so the select used to be set to
     '' and rendered as an empty box - blank at exactly the moment the customer
     has made the most specific choice on the card. Give it an option of its own
     instead, disabled so it cannot be picked FROM the list, only shown in it.
     Passing null takes the option away again when the pair matches. */
  function setCustomOption(select, summary){
    if(!select) return;
    var opt = select.querySelector('option[value="__custom"]');
    if(!summary){
      if(opt) opt.parentNode.removeChild(opt);
      return;
    }
    if(!opt){
      opt = document.createElement('option');
      opt.value = '__custom';
      opt.disabled = true;
      select.insertBefore(opt, select.firstChild);
    }
    opt.textContent = summary;
    select.value = '__custom';
  }

  function refreshCard(idx, skipForceInputValue){
    var card = document.querySelector('.gsc-card[data-idx="' + idx + '"]');
    if(!card) return;
    var s = STATE[idx];
    var sz = STRUT_SIZES[idx];
    var img = card.querySelector('.gsc-card-img img');
    img.src = compositeUrl(s.shaftFit, s.bodyFit, s.shaftBall, s.bodyBall);

    var select = card.querySelector('.gsc-fit-select');
    var fitnote = card.querySelector('.gsc-card-fitnote');
    /* A withdrawn fitting (M8 Thread) has no <option>, so a code scanned with a
       '0' segment cannot be shown as the select's value - it reads as a custom
       build instead, which is what it now is. */
    var selectable = !!(FIT_MAP[s.shaftFit] && !FIT_MAP[s.shaftFit].hidden && FIT_MAP[s.bodyFit] && !FIT_MAP[s.bodyFit].hidden);
    if(selectable && s.shaftFit === s.bodyFit && s.shaftBall === s.bodyBall){
      setCustomOption(select, null);
      select.value = s.shaftFit;
      var f = FIT_MAP[s.shaftFit];
      fitnote.textContent = f ? f.desc : '';
    } else {
      var summary = 'Custom: ' + fitName(s.shaftFit) + (s.shaftBall ? ' +ball stud' : '') + ' shaft / ' + fitName(s.bodyFit) + (s.bodyBall ? ' +ball stud' : '') + ' body';
      setCustomOption(select, summary);
      fitnote.textContent = summary;
    }

    var qtyInput = card.querySelector('.gsc-qty input');
    qtyInput.value = s.qty;

    var forceNum = card.querySelector('.gsc-force-num');
    var forceSlider = card.querySelector('.gsc-force-slider');
    var forceConv = card.querySelector('.gsc-force-conv');
    if(!skipForceInputValue){ forceNum.value = s.force; }
    forceSlider.value = s.force;
    forceConv.textContent = forceToLbs(s.force) + ' lbs · ' + forceToKg(s.force) + ' kg';

    var codeEl = card.querySelector('.gsc-card-code strong');
    var code = buildProductCode(sz.diam, sz.len, s.force, s.shaftFit, s.shaftBall, s.bodyFit, s.bodyBall);
    codeEl.textContent = code || 'Contact us to confirm';
  }

  function buildStrutCard(idx){
    var s = STRUT_SIZES[idx];
    var diam = s.diam, len = s.len, qty = s.qty;
    var outOfStock = qty <= 0;

    var card = document.createElement('div');
    card.className = 'gsc-card';
    card.setAttribute('data-idx', idx);

    var imgWrap = document.createElement('div');
    imgWrap.className = 'gsc-card-img';
    var img = document.createElement('img');
    img.src = compositeUrl(DEFAULT_FIT, DEFAULT_FIT);
    img.alt = diam + 'mm x ' + len + 'mm gas strut';
    imgWrap.appendChild(img);
    imgWrap.addEventListener('click', function(){ GSC.openModal(idx); });
    card.appendChild(imgWrap);

    var body = document.createElement('div');
    body.className = 'gsc-card-body';

    var size = document.createElement('div');
    size.className = 'gsc-card-size';
    size.textContent = diam + 'mm × ' + len + 'mm';
    body.appendChild(size);

    var stock = document.createElement('div');
    stock.className = 'gsc-card-stock' + (outOfStock ? ' out-of-stock' : ' in-stock');
    stock.textContent = outOfStock ? 'Out of Stock' : 'In Stock';
    body.appendChild(stock);

    var codeRow = document.createElement('div');
    codeRow.className = 'gsc-card-code';
    codeRow.innerHTML = 'Code: <strong>-</strong>';
    body.appendChild(codeRow);

    var select = document.createElement('select');
    select.className = 'gsc-fit-select';
    FIT_CHOICES.forEach(function(f){
      var opt = document.createElement('option');
      opt.value = f.id;
      opt.textContent = f.name + ' (both ends)';
      select.appendChild(opt);
    });
    select.value = DEFAULT_FIT;
    select.addEventListener('change', function(){
      STATE[idx].shaftFit = select.value;
      STATE[idx].bodyFit = select.value;
      STATE[idx].shaftBall = STATE[idx].shaftBall && FIT_MAP[select.value].studCompatible;
      STATE[idx].bodyBall = STATE[idx].bodyBall && FIT_MAP[select.value].studCompatible;
      refreshCard(idx);
    });
    body.appendChild(select);

    var fitnoteRow = document.createElement('div');
    fitnoteRow.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:8px;';
    var fitnote = document.createElement('div');
    fitnote.className = 'gsc-card-fitnote';
    fitnote.textContent = FIT_CHOICES[0].desc;
    fitnoteRow.appendChild(fitnote);

    var shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'gsc-share-icon-btn';
    shareBtn.title = 'Share a link to this exact build';
    shareBtn.setAttribute('aria-label', 'Share a link to this exact build');
    shareBtn.style.cssText = 'flex-shrink:0;width:24px;height:24px;padding:0;display:flex;align-items:center;justify-content:center;background:none;border:1px solid #d8d8d4;border-radius:4px;cursor:pointer;color:#55555a;';
    shareBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>';
    fitnoteRow.appendChild(shareBtn);
    body.appendChild(fitnoteRow);

    shareBtn.addEventListener('click', function(){
      if(!window.StruxaShare) return;
      var st = STATE[idx];
      var qtyToShare = (st && st.qty) ? st.qty : 1;
      var fitLabelShare = buildFitLabel(st.shaftFit, st.shaftBall, st.bodyFit, st.bodyBall);
      var codeValShare = buildProductCode(diam, len, st.force, st.shaftFit, st.shaftBall, st.bodyFit, st.bodyBall);
      var shareItem = {
        id: s.variantId,
        quantity: qtyToShare,
        properties: {
          '_Full Name': fullStrutName(diam, len, st.force),
          // Private: hidden from the buyer, kept on the order.
          '_Pressure (N)': String(st.force),
          'End Fittings': fitLabelShare,
          'Code': codeValShare || 'Contact us to confirm'
        },
        title: diam + 'mm x ' + len + 'mm Gas Strut - ' + fitLabelShare + ' - ' + st.force + 'N',
        image: compositeUrl(st.shaftFit, st.bodyFit, st.shaftBall, st.bodyBall),
        price: PRICES[diam] ? Math.round(PRICES[diam] * 100) : null
      };
      var shareUrl = window.StruxaShare.buildShareUrl([shareItem]);
      shareLink(shareBtn, shareUrl, shareItem.title, 'Share a link to this exact build');
    });

    var customizeLink = document.createElement('button');
    customizeLink.type = 'button';
    customizeLink.className = 'gsc-customize-link';
    customizeLink.textContent = 'Set ends & ball studs individually →';
    customizeLink.addEventListener('click', function(){ GSC.openModal(idx); });
    body.appendChild(customizeLink);

    // pressure / force block
    var forceBlock = document.createElement('div');
    forceBlock.className = 'gsc-force-block';
    var forceHead = document.createElement('div');
    forceHead.className = 'gsc-force-head';
    var forceLabel = document.createElement('span');
    forceLabel.textContent = 'Pressure (N)';
    var forceNum = document.createElement('input');
    forceNum.type = 'number';
    forceNum.className = 'gsc-force-num';
    forceNum.min = FORCE_MIN; forceNum.max = FORCE_MAX; forceNum.step = FORCE_STEP;
    forceNum.value = FORCE_DEFAULT;
    forceHead.appendChild(forceLabel);
    forceHead.appendChild(forceNum);
    forceBlock.appendChild(forceHead);

    var forceSlider = document.createElement('input');
    forceSlider.type = 'range';
    forceSlider.className = 'gsc-force-slider';
    forceSlider.min = FORCE_MIN; forceSlider.max = FORCE_MAX; forceSlider.step = FORCE_STEP;
    forceSlider.value = FORCE_DEFAULT;
    forceBlock.appendChild(forceSlider);

    var forceConv = document.createElement('div');
    forceConv.className = 'gsc-force-conv';
    forceConv.textContent = forceToLbs(FORCE_DEFAULT) + ' lbs · ' + forceToKg(FORCE_DEFAULT) + ' kg';
    forceBlock.appendChild(forceConv);

    function setForce(v){
      v = Math.max(FORCE_MIN, Math.min(FORCE_MAX, Math.round(v / FORCE_STEP) * FORCE_STEP));
      STATE[idx].force = v;
      refreshCard(idx);
    }
    // While the user is actively typing in the number field, update everything
    // (slider position, lbs/kg conversion, product code) EXCEPT the number field's
    // own value - refreshCard() used to overwrite it on every keystroke via
    // rounding/clamping, which made it impossible to type a value like "450"
    // (it would snap back after each digit). Only round/clamp on blur or Enter.
    forceNum.addEventListener('input', function(){
      if(this.value === '') return;
      var v = +this.value;
      if(isNaN(v)) return;
      STATE[idx].force = v;
      refreshCard(idx, true);
    });
    forceNum.addEventListener('change', function(){
      setForce(this.value === '' ? FORCE_DEFAULT : +this.value);
    });
    forceSlider.addEventListener('input', function(){ setForce(+this.value); });

    body.appendChild(forceBlock);

    // qty + price row
    var row = document.createElement('div');
    row.className = 'gsc-row';

    var qtyWrap = document.createElement('div');
    qtyWrap.className = 'gsc-qty';
    var qtyMinus = document.createElement('button');
    qtyMinus.type = 'button'; qtyMinus.textContent = '−';
    var qtyInput = document.createElement('input');
    // No upper cap here - people can type any quantity they want (e.g. 100).
    // If it's more than we actually have in stock, checkQtyAgainstStock()
    // below surfaces a warning + bulk order link instead of silently
    // blocking the number.
    qtyInput.type = 'number'; qtyInput.min = '1'; qtyInput.value = '1';
    var qtyPlus = document.createElement('button');
    qtyPlus.type = 'button'; qtyPlus.textContent = '+';

    var qtyWarning = document.createElement('div');
    qtyWarning.className = 'gsc-qty-warning';

    var bulkNudge = document.createElement('div');
    bulkNudge.className = 'gsc-bulk-nudge';

    var BULK_DISCOUNT_QTY = SX_BULK_QTY;

    function updateBulkNudge(){
      var v = STATE[idx].qty;
      if(v >= BULK_DISCOUNT_QTY){
        bulkNudge.innerHTML = 'Bulk order discount applied - <strong>' + SX_BULK_PCT + '% off</strong>';
        bulkNudge.classList.add('show');
      } else {
        bulkNudge.classList.remove('show');
      }
    }

    function checkQtyAgainstStock(){
      var v = STATE[idx].qty;
      var overStock = !outOfStock && v > qty;
      if(overStock){
        qtyWarning.innerHTML = 'Only <strong>' + qty + '</strong> in stock right now. Need ' + v + '? <button type="button" class="gsc-bulk-link">Request a bulk order</button> for the rest.';
        qtyWarning.classList.add('show');
        var bulkBtn = qtyWarning.querySelector('.gsc-bulk-link');
        if(bulkBtn){ bulkBtn.addEventListener('click', function(){ GSC.openBulkModal(idx, v); }); }
      } else {
        qtyWarning.classList.remove('show');
      }
      var cta = card.querySelector('.gsc-card-cta:not(.preorder)');
      if(cta) cta.disabled = overStock;
      updateBulkNudge();
      return overStock;
    }

    qtyMinus.addEventListener('click', function(){
      STATE[idx].qty = Math.max(1, STATE[idx].qty - 1);
      refreshCard(idx);
      checkQtyAgainstStock();
    });
    qtyPlus.addEventListener('click', function(){
      STATE[idx].qty = STATE[idx].qty + 1;
      refreshCard(idx);
      checkQtyAgainstStock();
    });
    qtyInput.addEventListener('change', function(){
      var v = Math.max(1, parseInt(this.value, 10) || 1);
      STATE[idx].qty = v;
      refreshCard(idx);
      checkQtyAgainstStock();
    });
    qtyWrap.appendChild(qtyMinus);
    qtyWrap.appendChild(qtyInput);
    qtyWrap.appendChild(qtyPlus);
    row.appendChild(qtyWrap);

    var price = priceNode(PRICES[diam]);
    price.className += (price.className ? ' ' : '') + 'gsc-card-price';
    row.appendChild(price);

    body.appendChild(row);
    body.appendChild(qtyWarning);
    body.appendChild(bulkNudge);
    updateBulkNudge();

    if(!outOfStock){
      var cta = document.createElement('button');
      cta.className = 'gsc-card-cta';
      cta.type = 'button';
      cta.textContent = 'Add to Cart';
      body.appendChild(cta);

      var toast = document.createElement('div');
      toast.className = 'gsc-card-toast';
      body.appendChild(toast);

      cta.addEventListener('click', function(){
        if(checkQtyAgainstStock()) return;
        var qtyToAdd = (STATE[idx] && STATE[idx].qty) ? STATE[idx].qty : 1;
        var st = STATE[idx];
        var fitLabel = buildFitLabel(st.shaftFit, st.shaftBall, st.bodyFit, st.bodyBall);
        var codeVal = buildProductCode(diam, len, st.force, st.shaftFit, st.shaftBall, st.bodyFit, st.bodyBall);
        var extraProps = {
          '_Full Name': fullStrutName(diam, len, st.force),
          // Private: hidden from the buyer, kept on the order.
          '_Pressure (N)': String(st.force),
          'End Fittings': fitLabel,
          'Code': codeVal || 'Contact us to confirm'
        };
        addFittingToCart(s.variantId, qtyToAdd, null, cta, toast, extraProps);
      });
    } else {
      var oosRow = document.createElement('div');
      oosRow.className = 'gsc-oos-row';

      var notifyLink = document.createElement('button');
      notifyLink.type = 'button';
      notifyLink.className = 'gsc-btn-secondary gsc-oos-btn';
      notifyLink.textContent = 'Notify When In Stock';
      oosRow.appendChild(notifyLink);

      body.appendChild(oosRow);

      /* No pre-order button and no lead time. Dave, 14/09/2026: "we dont want
         pre order, remove that." A length we do not already hold is a
         production run, not a shelf pick, so the only honest offer on an
         out-of-stock size is to tell them when it lands. Someone who needs a
         size we do not stock at all has the request form further down the
         page. */

      var notifyForm = document.createElement('div');
      notifyForm.className = 'gsc-notify-form';
      var notifyInput = document.createElement('input');
      notifyInput.type = 'email';
      notifyInput.placeholder = 'you@email.com';
      var notifyBtn = document.createElement('button');
      notifyBtn.type = 'button';
      notifyBtn.textContent = 'Notify Me';
      notifyForm.appendChild(notifyInput);
      notifyForm.appendChild(notifyBtn);
      body.appendChild(notifyForm);

      var notifyMsg = document.createElement('div');
      notifyMsg.className = 'gsc-notify-msg';
      notifyMsg.textContent = 'Got it - we\'ll email you when this size is back in stock.';
      body.appendChild(notifyMsg);

      notifyLink.addEventListener('click', function(){
        notifyForm.classList.toggle('show');
      });
      /* THIS USED TO POST NOWHERE. The handler checked for an "@", hid the
         form and showed "we'll email you when this size is back in stock" -
         and that was the whole of it. No request was recorded and nobody was
         ever emailed, so every address typed into this card since it shipped
         was discarded while the customer was thanked for it.

         /apps/rewards/notify-signup is the endpoint that already does this
         for snippets/sx-notify-me.liquid. It writes to struxa:bis, which the
         app reads on its Back-in-Stock screen, and it needs only email and
         variantId - both of which this card already has.

         A failure now says so. Being told to try again is recoverable; being
         thanked for nothing is not. */
      notifyBtn.addEventListener('click', function(){
        var email = (notifyInput.value || '').trim();
        if(!email || email.indexOf('@') < 0){
          notifyInput.focus();
          return;
        }
        var sz = STRUT_SIZES[idx];
        notifyBtn.disabled = true;
        notifyBtn.textContent = 'Sending\u2026';
        fetch('/apps/rewards/notify-signup', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            variantId: sz.variantId,
            productTitle: sz.diam + 'mm Gas Strut',
            variantTitle: sz.len + 'mm'
          })
        })
          .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
          .then(function(){
            notifyForm.classList.remove('show');
            notifyMsg.classList.add('show');
          })
          .catch(function(){
            notifyMsg.textContent = 'That did not save - please try again, or email us.';
            notifyMsg.classList.add('show', 'is-error');
          })
          .finally(function(){
            notifyBtn.disabled = false;
            notifyBtn.textContent = 'Notify Me';
          });
      });
    }

    card.appendChild(body);
    return card;
  }

  function buildFitInfoCard(f){
    var card = document.createElement('div');
    card.className = 'gsc-fit-card';

    var productUrl = END_FITTING_URLS[f.id] || null;

    var imgEl = null;
    var imgWrap = document.createElement('div');
    if(f.img){
      imgWrap.className = 'gsc-card-img';
      imgEl = document.createElement('img');
      imgEl.src = R2 + '/' + FIT_STANDALONE_IMG[f.id];
      imgEl.alt = f.name;
      if(productUrl){
        var imgLink = document.createElement('a');
        imgLink.href = productUrl;
        imgLink.appendChild(imgEl);
        imgWrap.appendChild(imgLink);
      } else {
        imgWrap.appendChild(imgEl);
      }
    } else {
      imgWrap.className = 'gsc-card-img gsc-img-placeholder';
      var ph = document.createElement('div');
      ph.className = 'gsc-img-placeholder-text';
      ph.textContent = 'Photo coming soon';
      imgWrap.appendChild(ph);
    }
    card.appendChild(imgWrap);

    var body = document.createElement('div');
    body.className = 'gsc-fit-card-body';
    var name = document.createElement('div');
    name.className = 'gsc-fit-card-name';
    if(productUrl){
      var nameLink = document.createElement('a');
      nameLink.href = productUrl;
      nameLink.textContent = f.name;
      name.appendChild(nameLink);
    } else {
      name.textContent = f.name;
    }
    body.appendChild(name);
    var desc = document.createElement('div');
    desc.className = 'gsc-fit-card-desc';
    desc.textContent = f.desc;
    body.appendChild(desc);
    var code = document.createElement('div');
    code.className = 'gsc-fit-card-code';
    code.textContent = 'Code: ' + f.code;
    body.appendChild(code);
    var stud = document.createElement('div');
    stud.className = 'gsc-fit-card-stud' + (f.studCompatible ? '' : ' no');
    stud.textContent = f.studCompatible ? 'Ball stud compatible' : 'Not ball stud compatible';
    body.appendChild(stud);

    if(f.studCompatible && imgEl && FIT_STANDALONE_IMG_BALL[f.id]){
      var ballRow = document.createElement('label');
      ballRow.className = 'gsc-fit-ball-row';
      var ballCb = document.createElement('input');
      ballCb.type = 'checkbox';
      ballRow.appendChild(ballCb);
      var ballText = document.createElement('span');
      ballText.textContent = 'Add ball stud (no extra cost)';
      ballRow.appendChild(ballText);
      ballCb.addEventListener('change', function(){
        imgEl.src = R2 + '/' + (ballCb.checked ? FIT_STANDALONE_IMG_BALL[f.id] : FIT_STANDALONE_IMG[f.id]);
        code.textContent = 'Code: ' + ((ballCb.checked && f.ballCode) ? f.ballCode : f.code);
      });
      body.appendChild(ballRow);
    }

    var priceRow = priceNode(5);
    priceRow.className += (priceRow.className ? ' ' : '') + 'gsc-fit-card-price';
    body.appendChild(priceRow);

    var cartRow = document.createElement('div');
    cartRow.className = 'gsc-row';
    var fitQtyWrap = document.createElement('div');
    fitQtyWrap.className = 'gsc-qty';
    var fitQtyMinus = document.createElement('button');
    fitQtyMinus.type = 'button'; fitQtyMinus.textContent = '−';
    var fitQtyInput = document.createElement('input');
    fitQtyInput.type = 'number'; fitQtyInput.min = '1'; fitQtyInput.value = '1';
    var fitQtyPlus = document.createElement('button');
    fitQtyPlus.type = 'button'; fitQtyPlus.textContent = '+';
    fitQtyMinus.addEventListener('click', function(){
      fitQtyInput.value = Math.max(1, (parseInt(fitQtyInput.value, 10) || 1) - 1);
    });
    fitQtyPlus.addEventListener('click', function(){
      fitQtyInput.value = (parseInt(fitQtyInput.value, 10) || 1) + 1;
    });
    fitQtyWrap.appendChild(fitQtyMinus);
    fitQtyWrap.appendChild(fitQtyInput);
    fitQtyWrap.appendChild(fitQtyPlus);
    cartRow.appendChild(fitQtyWrap);

    var fitShareBtn = document.createElement('button');
    fitShareBtn.type = 'button';
    fitShareBtn.className = 'gsc-share-icon-btn';
    fitShareBtn.title = 'Share a link to this item';
    fitShareBtn.setAttribute('aria-label', 'Share a link to this item');
    fitShareBtn.style.cssText = 'flex-shrink:0;width:24px;height:24px;padding:0;display:flex;align-items:center;justify-content:center;background:none;border:1px solid #d8d8d4;border-radius:4px;cursor:pointer;color:#55555a;';
    fitShareBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>';
    cartRow.appendChild(fitShareBtn);
    body.appendChild(cartRow);

    var fitCta = document.createElement('button');
    fitCta.type = 'button';
    fitCta.className = 'gsc-card-cta';
    fitCta.textContent = 'Add to Cart';
    body.appendChild(fitCta);

    var fitMsg = document.createElement('div');
    fitMsg.className = 'gsc-fit-cart-msg';
    body.appendChild(fitMsg);

    fitCta.addEventListener('click', function(){
      var qty = Math.max(1, parseInt(fitQtyInput.value, 10) || 1);
      var ballStud = (typeof ballCb !== 'undefined' && ballCb) ? ballCb.checked : null;
      addFittingToCart(END_FITTING_VARIANTS[f.id], qty, ballStud, fitCta, fitMsg);
    });

    fitShareBtn.addEventListener('click', function(){
      if(!window.StruxaShare) return;
      var qty = Math.max(1, parseInt(fitQtyInput.value, 10) || 1);
      var ballStud = (typeof ballCb !== 'undefined' && ballCb) ? ballCb.checked : null;
      var props = {};
      if(ballStud !== null){ props['Ball Stud'] = ballStud ? 'Yes' : 'No'; }
      var url = window.StruxaShare.buildShareUrl([{
        id: END_FITTING_VARIANTS[f.id],
        quantity: qty,
        properties: props,
        title: f.name + (ballStud ? ' + ball stud' : ''),
        image: imgEl ? imgEl.src : '',
        price: 500
      }]);
      shareLink(fitShareBtn, url, f.name + (ballStud ? ' + ball stud' : ''), 'Share a link to this item');
    });

    card.appendChild(body);
    return card;
  }

  function buildBracketCard(b){
    var card = document.createElement('div');
    card.className = 'gsc-fit-card';

    var brProductUrl = BRACKET_URLS[b.id] || null;

    var imgWrap = document.createElement('div');
    imgWrap.className = 'gsc-card-img';
    var imgEl = document.createElement('img');
    imgEl.src = b.img;
    imgEl.alt = b.name;
    if(brProductUrl){
      var brImgLink = document.createElement('a');
      brImgLink.href = brProductUrl;
      brImgLink.appendChild(imgEl);
      imgWrap.appendChild(brImgLink);
    } else {
      imgWrap.appendChild(imgEl);
    }
    card.appendChild(imgWrap);

    var body = document.createElement('div');
    body.className = 'gsc-fit-card-body';
    var name = document.createElement('div');
    name.className = 'gsc-fit-card-name';
    if(brProductUrl){
      var brNameLink = document.createElement('a');
      brNameLink.href = brProductUrl;
      brNameLink.textContent = b.name;
      name.appendChild(brNameLink);
    } else {
      name.textContent = b.name;
    }
    body.appendChild(name);
    var desc = document.createElement('div');
    desc.className = 'gsc-fit-card-desc';
    desc.textContent = b.desc;
    body.appendChild(desc);

    var priceRow = priceNode(b.price);
    priceRow.className += (priceRow.className ? ' ' : '') + 'gsc-fit-card-price';
    body.appendChild(priceRow);

    var cartRow = document.createElement('div');
    cartRow.className = 'gsc-row';
    var brQtyWrap = document.createElement('div');
    brQtyWrap.className = 'gsc-qty';
    var brQtyMinus = document.createElement('button');
    brQtyMinus.type = 'button'; brQtyMinus.textContent = '−';
    var brQtyInput = document.createElement('input');
    brQtyInput.type = 'number'; brQtyInput.min = '1'; brQtyInput.value = '1';
    var brQtyPlus = document.createElement('button');
    brQtyPlus.type = 'button'; brQtyPlus.textContent = '+';
    brQtyMinus.addEventListener('click', function(){
      brQtyInput.value = Math.max(1, (parseInt(brQtyInput.value, 10) || 1) - 1);
    });
    brQtyPlus.addEventListener('click', function(){
      brQtyInput.value = (parseInt(brQtyInput.value, 10) || 1) + 1;
    });
    brQtyWrap.appendChild(brQtyMinus);
    brQtyWrap.appendChild(brQtyInput);
    brQtyWrap.appendChild(brQtyPlus);
    cartRow.appendChild(brQtyWrap);

    var brShareBtn = document.createElement('button');
    brShareBtn.type = 'button';
    brShareBtn.className = 'gsc-share-icon-btn';
    brShareBtn.title = 'Share a link to this item';
    brShareBtn.setAttribute('aria-label', 'Share a link to this item');
    brShareBtn.style.cssText = 'flex-shrink:0;width:24px;height:24px;padding:0;display:flex;align-items:center;justify-content:center;background:none;border:1px solid #d8d8d4;border-radius:4px;cursor:pointer;color:#55555a;';
    brShareBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>';
    cartRow.appendChild(brShareBtn);
    body.appendChild(cartRow);

    var brCta = document.createElement('button');
    brCta.type = 'button';
    brCta.className = 'gsc-card-cta';
    brCta.textContent = 'Add to Cart';
    body.appendChild(brCta);

    var brMsg = document.createElement('div');
    brMsg.className = 'gsc-fit-cart-msg';
    body.appendChild(brMsg);

    brCta.addEventListener('click', function(){
      var qty = Math.max(1, parseInt(brQtyInput.value, 10) || 1);
      addFittingToCart(BRACKET_VARIANTS[b.id], qty, null, brCta, brMsg);
    });

    brShareBtn.addEventListener('click', function(){
      if(!window.StruxaShare) return;
      var qty = Math.max(1, parseInt(brQtyInput.value, 10) || 1);
      var url = window.StruxaShare.buildShareUrl([{
        id: BRACKET_VARIANTS[b.id],
        quantity: qty,
        properties: {},
        title: b.name,
        image: b.img,
        price: Math.round(b.price * 100)
      }]);
      shareLink(brShareBtn, url, b.name, 'Share a link to this item');
    });

    card.appendChild(body);
    return card;
  }

  function updateClRange(){
    var diamSelect = document.getElementById('gscClDiam');
    var lenInput = document.getElementById('gscClLength');
    var rangeEl = document.getElementById('gscClRange');
    var priceEl = document.getElementById('gscClPrice');
    var qtyInput = document.getElementById('gscClQty');
    if(!diamSelect || !lenInput || !rangeEl) return;
    var diam = +diamSelect.value;
    var r = LENGTH_RANGE[diam];
    if(!r) return;
    rangeEl.textContent = diam + 'mm shaft: ' + r.min + 'mm - ' + r.max + 'mm';
    lenInput.min = r.min;
    lenInput.max = r.max;
    if(priceEl){
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      priceEl.innerHTML = priceLineHtml(diam, qty);
    }
  }

  function goToCustomLength(len){
    var section = document.getElementById('gscCustomLength');
    if(!section) return;
    var lenInput = document.getElementById('gscClLength');
    if(len && lenInput){ lenInput.value = len; }
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initCustomLengthForm(){
    var diamSelect = document.getElementById('gscClDiam');
    var form = document.getElementById('gscClForm');
    var preorderBtn = document.getElementById('gscClPreorderBtn');
    var qtyInput = document.getElementById('gscClQty');
    if(!diamSelect || !form) return;
    diamSelect.addEventListener('change', updateClRange);
    if(qtyInput){ qtyInput.addEventListener('input', updateClRange); }
    updateClRange();

    function validateCl(){
      var diam = +diamSelect.value;
      var len = +document.getElementById('gscClLength').value;
      var email = document.getElementById('gscClEmail').value;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var forceEl = document.getElementById('gscClForce');
      var force = forceEl ? parseInt(forceEl.value, 10) : 0;
      var errorEl = document.getElementById('gscClError');
      var msgEl = document.getElementById('gscClMsg');
      errorEl.classList.remove('show');
      msgEl.classList.remove('show');
      var r = LENGTH_RANGE[diam];
      if(!len || (r && (len < r.min || len > r.max))){
        errorEl.textContent = 'Please enter a length between ' + r.min + 'mm and ' + r.max + 'mm for ' + diam + 'mm shaft.';
        errorEl.classList.add('show');
        return null;
      }
      if(!email || email.indexOf('@') === -1){
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.classList.add('show');
        return null;
      }
      if(force && (force < FORCE_MIN || force > FORCE_MAX)){
        errorEl.textContent = 'Pressure must be between ' + FORCE_MIN + 'N and ' + FORCE_MAX + 'N, or leave it blank and we will advise.';
        errorEl.classList.add('show');
        return null;
      }
      return { diam: diam, len: len, email: email, qty: qty, force: force || 0 };
    }

    /* Struxa: BOTH of these used to show a confirmation and send nothing - the
       email address went nowhere, so "we'll email you when it's back" was not
       true. They now post to the same Formspree endpoint the bulk request uses.
       The pre-order button is gone: minimum order for a new length is 50 pieces,
       so a request for two struts is a demand signal, not an order. */
    function sendClRequest(){
      var data = validateCl();
      if(!data) return;
      var msgEl = document.getElementById('gscClMsg');
      var errEl = document.getElementById('gscClError');
      var btn = form.querySelector('.gsc-cl-submit');
      var origText = btn ? btn.textContent : '';
      if(btn){ btn.disabled = true; btn.textContent = 'Sending…'; }
      var fd = new FormData();
      fd.append('email', data.email);
      fd.append('shaft_diameter', data.diam + 'mm');
      fd.append('length', data.len + 'mm');
      fd.append('quantity', String(data.qty));
      fd.append('desired_pressure', data.force ? data.force + 'N' : 'not specified - advise');
      fd.append('request', 'Size not currently stocked - register demand');
      fd.append('_subject', 'Struxa - Size request: ' + data.diam + 'mm × ' + data.len + 'mm' + (data.force ? ' @ ' + data.force + 'N' : '') + ' (qty ' + data.qty + ')');
      /* Record it in the app as well. The Formspree post below is what
         reaches Dave; this is the copy that can be COUNTED, so "which lengths
         should we stock next" and "what has this customer asked us for" have
         somewhere to be answered from. An email in an inbox answers neither.

         Fire and forget on purpose: if this fails the customer still gets
         their confirmation and Dave still gets his email. The request
         reaching a human matters more than the request being countable. */
      try {
        fetch('https://project-a7p0q.vercel.app/api', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'log-size-request', params: {
            diam: data.diam,
            len: data.len,
            force: data.force || null,
            qty: data.qty,
            email: data.email,
            customerId: (window.GSC_DATA && window.GSC_DATA.customerId) || null,
            customerName: (window.GSC_DATA && window.GSC_DATA.customerName) || '',
            businessName: (window.SX_TRADE && window.SX_TRADE.business) || ''
          } })
        }).catch(function(){});
      } catch(e){}

      fetch('https://formspree.io/f/maqgbndr', {
        method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
      }).then(function(res){
        if(res.ok){
          msgEl.textContent = 'Request sent - ' + data.qty + ' × ' + data.diam + 'mm at ' + data.len + 'mm' + (data.force ? ' at ' + data.force + 'N' : '') + '. We will come back to you with a price and a timeframe.';
          msgEl.classList.add('show');
          form.reset();
          updateClRange();
        } else {
          errEl.textContent = 'Something went wrong sending that. Please email info@struxamotion.com directly.';
          errEl.classList.add('show');
        }
      }).catch(function(){
        errEl.textContent = 'Something went wrong sending that. Please email info@struxamotion.com directly.';
        errEl.classList.add('show');
      }).finally(function(){
        if(btn){ btn.disabled = false; btn.textContent = origText; }
      });
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      sendClRequest();
    });

    if(preorderBtn){ preorderBtn.addEventListener('click', sendClRequest); }
  }

  function parseProductCode(code){
    if(!code) return null;
    var m = /^([A-D])-(\d{2,4})-(\d{1,3})-(\d A?)-(\d A?)$/i;
    // allow both "1A" and "1 A" just in case, but primarily match "1A"
    var m2 = /^([A-D])-(\d{2,4})-(\d{1,3})-(\d[A]?)-(\d[A]?)$/i.exec(code.trim().toUpperCase());
    if(!m2) return null;
    var letter = m2[1], len = parseInt(m2[2],10), forceTens = parseInt(m2[3],10);
    var force = forceTens * 10;
    var diam = null;
    Object.keys(SHAFT_LETTER).forEach(function(d){ if(SHAFT_LETTER[d] === letter) diam = parseInt(d,10); });
    if(!diam) return null;
    function resolveFit(token){
      var hasBall = /A$/.test(token);
      var numCode = token.replace('A','');
      var match = null;
      END_FITTINGS_INFO.forEach(function(f){
        if(token === f.ballCode || (!hasBall && numCode === f.code)) match = f;
      });
      if(!match) return null;
      return { id: match.id, ball: hasBall && !!match.ballCode };
    }
    var shaft = resolveFit(m2[4]);
    var body = resolveFit(m2[5]);
    if(!shaft || !body) return null;
    return { diam: diam, len: len, force: force, shaftFit: shaft.id, shaftBall: shaft.ball, bodyFit: body.id, bodyBall: body.ball };
  }

  function showCodeNotice(html){
    var existing = document.getElementById('gscCodeNotice');
    if(existing) existing.remove();
    var body = document.querySelector('.gsc-body');
    if(!body) return;
    var notice = document.createElement('div');
    notice.className = 'gsc-info-banner';
    notice.id = 'gscCodeNotice';
    notice.style.borderLeftColor = '#ff7a00';
    notice.innerHTML = html + ' <button type="button" id="gscCodeNoticeClose" style="float:right;border:none;background:none;cursor:pointer;font-size:13px;color:inherit;text-decoration:underline;">Dismiss</button>';
    body.insertBefore(notice, body.firstChild);
    var closeBtn = document.getElementById('gscCodeNoticeClose');
    if(closeBtn) closeBtn.addEventListener('click', function(){ notice.remove(); });
  }

  function applyCodeParam(){
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    if(!code) return;
    var parsed = parseProductCode(code);
    if(!parsed) return;
    var idx = -1;
    STRUT_SIZES.forEach(function(s, i){
      if(idx === -1 && s.diam === parsed.diam && s.len === parsed.len) idx = i;
    });
    var isExact = idx !== -1;
    if(!isExact){
      // No exact length in stock for this shaft diameter - show the closest
      // length we do stock for that same diameter instead (diameters aren't
      // interchangeable, so we never substitute across shaft sizes).
      var bestDist = Infinity;
      STRUT_SIZES.forEach(function(s, i){
        if(s.diam !== parsed.diam) return;
        var dist = Math.abs(s.len - parsed.len);
        if(dist < bestDist){ bestDist = dist; idx = i; }
      });
    }
    if(idx === -1) return;
    STATE[idx].shaftFit = parsed.shaftFit;
    STATE[idx].bodyFit = parsed.bodyFit;
    STATE[idx].shaftBall = parsed.shaftBall;
    STATE[idx].bodyBall = parsed.bodyBall;
    STATE[idx].force = parsed.force;
    refreshCard(idx);
    if(!isExact){
      var sz = STRUT_SIZES[idx];
      showCodeNotice('<strong>Closest match shown:</strong> we don’t stock ' + parsed.diam + 'mm × ' + parsed.len + 'mm exactly - here’s the nearest size we carry (' + sz.diam + 'mm × ' + sz.len + 'mm). Need the exact length? Use the Need a Different Length form below.');
    }
    setTimeout(function(){
      var card = document.querySelector('.gsc-card[data-idx="' + idx + '"]');
      if(card){
        card.scrollIntoView({ behavior:'smooth', block:'center' });
        card.style.outline = '3px solid #ff7a00';
        card.style.outlineOffset = '4px';
        card.style.transition = 'outline-color 0.3s';
        setTimeout(function(){ card.style.outline = ''; card.style.outlineOffset = ''; }, 3500);
      }
    }, 300);
  }

  /* ── Length picker ──────────────────────────────────────────────────────
     Dave: "can we show the length of the strut dropdown similar to the
     vehicel store but for hte all gas struts page too? like put it where the
     installtion length part is".

     Built here rather than in the markup because this page exists twice -
     templates/page.gas-struts-catalogue.json serves /pages/all-gas-struts and
     snippets/sx-gas-struts-catalogue.liquid serves the copy inside the trade
     portal. Both load this file, so one implementation covers both and there
     is no third copy of the markup to fall out of step.

     It filters rather than scrolls. With a couple of dozen sizes on screen the
     question is "show me the 520s", and scrolling to a card answers it while
     leaving every other length in view.

     display rather than the hidden attribute: the grid sets display on
     .gsc-card, which wins over [hidden] unless the stylesheet says otherwise,
     and a filter that silently does nothing is worse than no filter. */
  function buildLengthPicker(grid){
    var lengths = STRUT_SIZES.map(function(s){ return s.len; })
      .filter(function(v, i, a){ return a.indexOf(v) === i; })
      .sort(function(a, b){ return a - b; });
    if(lengths.length < 2) return null;

    var wrap = document.createElement('div');
    wrap.className = 'gsc-length-jump';

    var label = document.createElement('label');
    label.className = 'gsc-filter-label';
    label.setAttribute('for', 'gscLengthSelect');
    label.textContent = 'Installation length';

    var sel = document.createElement('select');
    sel.className = 'gsc-filter-select';
    sel.id = 'gscLengthSelect';
    var optAll = document.createElement('option');
    optAll.value = 'all';
    optAll.textContent = 'All lengths (' + lengths.length + ')';
    sel.appendChild(optAll);
    lengths.forEach(function(L){
      var o = document.createElement('option');
      o.value = String(L);
      o.textContent = L + 'mm';
      sel.appendChild(o);
    });

    var count = document.createElement('span');
    count.className = 'gsc-length-jump-count';

    sel.addEventListener('change', function(){
      var want = this.value;
      var shown = 0;
      Array.prototype.forEach.call(grid.querySelectorAll('.gsc-card[data-idx]'), function(card){
        var sz = STRUT_SIZES[+card.getAttribute('data-idx')];
        var match = (want === 'all') || (sz && String(sz.len) === want);
        card.style.display = match ? '' : 'none';
        if(match) shown++;
      });
      count.textContent = (want === 'all')
        ? ''
        : shown + (shown === 1 ? ' strut' : ' struts') + ' at ' + want + 'mm';
    });

    wrap.appendChild(label);
    wrap.appendChild(sel);
    wrap.appendChild(count);
    return wrap;
  }

  function buildAll(){
    warmShareRefCode();
    var grid = document.getElementById('gscGridStruts');
    if(grid){
      STRUT_SIZES.forEach(function(s, idx){
        grid.appendChild(buildStrutCard(idx));
        refreshCard(idx);
      });
      /* Above the grid, which puts it directly under the "Installation Length
         is measured from..." banner - where Dave asked for it. */
      var picker = buildLengthPicker(grid);
      if(picker && grid.parentNode) grid.parentNode.insertBefore(picker, grid);
    }
    var fitGrid = document.getElementById('gscGridFittings');
    if(fitGrid){
      END_FITTINGS_INFO.forEach(function(f){
        if(f.hidden) return;
        fitGrid.appendChild(buildFitInfoCard(f));
      });
    }
    var brGrid = document.getElementById('gscGridBrackets');
    if(brGrid){
      BRACKETS_INFO.forEach(function(b){
        brGrid.appendChild(buildBracketCard(b));
      });
    }

    // modal selects populate once
    var modalShaft = document.getElementById('gscModalShaft');
    var modalBody = document.getElementById('gscModalBody');
    FIT_CHOICES.forEach(function(f){
      var o1 = document.createElement('option'); o1.value = f.id; o1.textContent = f.name;
      modalShaft.appendChild(o1);
      var o2 = document.createElement('option'); o2.value = f.id; o2.textContent = f.name;
      modalBody.appendChild(o2);
    });
    /* Struxa: the customise modal listed six fitting names and explained none of
       them. attachFitDesc drops a line under each select that changes with the
       selection, so the description sits where the choice is made rather than
       in a panel further down the page. */
    attachFitDesc(modalShaft);
    attachFitDesc(modalBody);
    attachStudNote(modalBody, 'gscModalStudNote');
    modalShaft.addEventListener('change', updateModalPreview);
    modalBody.addEventListener('change', updateModalPreview);
    document.getElementById('gscModalShaftBall').addEventListener('change', updateModalPreview);
    document.getElementById('gscModalBodyBall').addEventListener('change', updateModalPreview);

    /* The pre-order preview block was removed on 14/09/2026 with the rest of
       pre-ordering. It was already inert - every listener was guarded with
       if(preorderX) and those elements no longer exist - which is the reason
       to delete it rather than leave it: thirty lines that read as live, for a
       feature that is gone, which would have woken up the moment anyone added
       an element with a matching id. */

    var filterSelect = document.getElementById('gscFilterSelect');
    if(filterSelect){
      filterSelect.addEventListener('change', function(){ setFilter(this.value); });
    }

    initCustomLengthForm();
    applyLoggedInDefaults();
  }

  // If the shopper is signed in, don't make them re-type their email (and name,
  // on the bulk-order form) - prefill from their account and hide the field.
  function applyLoggedInDefaults(){
    var email = window.GSC_DATA && window.GSC_DATA.customerEmail;
    var name = window.GSC_DATA && window.GSC_DATA.customerName;
    function hideField(input){
      if(!input) return;
      input.value = input.value || '';
      var wrap = input.closest('.gsc-cl-field') || input.closest('.gsc-modal-field');
      if(wrap) wrap.style.display = 'none';
    }
    if(email){
      var clEmail = document.getElementById('gscClEmail');
      if(clEmail){ clEmail.value = email; hideField(clEmail); }
      var bulkEmail = document.getElementById('gscBulkEmail');
      if(bulkEmail){ bulkEmail.value = email; hideField(bulkEmail); }
    }
    if(name){
      var bulkName = document.getElementById('gscBulkName');
      if(bulkName){ bulkName.value = name; hideField(bulkName); }
    }
  }

  function updateModalPreview(){
    var modalShaft = document.getElementById('gscModalShaft');
    var modalBody = document.getElementById('gscModalBody');
    var modalImg = document.getElementById('gscModalImg');
    var modalShaftBall = document.getElementById('gscModalShaftBall');
    var modalBodyBall = document.getElementById('gscModalBodyBall');
    modalShaftBall.disabled = !FIT_MAP[modalShaft.value].studCompatible;
    modalBodyBall.disabled = !FIT_MAP[modalBody.value].studCompatible;
    if(modalShaftBall.disabled) modalShaftBall.checked = false;
    if(modalBodyBall.disabled) modalBodyBall.checked = false;
    modalImg.src = compositeUrl(modalShaft.value, modalBody.value, modalShaftBall.checked, modalBodyBall.checked);

    if(modalIdx !== null){
      var sz = STRUT_SIZES[modalIdx];
      var s = STATE[modalIdx];
      var code = buildProductCode(sz.diam, sz.len, s.force, modalShaft.value, modalShaftBall.checked, modalBody.value, modalBodyBall.checked);
      document.getElementById('gscModalCode').textContent = code || 'Contact us to confirm';
    }
  }

  function openModal(idx){
    modalIdx = idx;
    var s = STATE[idx];
    var sz = STRUT_SIZES[idx];
    document.getElementById('gscModalTitle').textContent = 'Customize Ends - ' + sz.diam + 'mm × ' + sz.len + 'mm';
    document.getElementById('gscModalShaft').value = s.shaftFit;
    document.getElementById('gscModalBody').value = s.bodyFit;
    document.getElementById('gscModalShaftBall').checked = s.shaftBall;
    document.getElementById('gscModalBodyBall').checked = s.bodyBall;
    updateModalPreview();
    document.getElementById('gscModalOverlay').classList.add('show');
  }

  function closeModal(){
    document.getElementById('gscModalOverlay').classList.remove('show');
    modalIdx = null;
  }

  function applyModal(){
    if(modalIdx === null) return;
    STATE[modalIdx].shaftFit = document.getElementById('gscModalShaft').value;
    STATE[modalIdx].bodyFit = document.getElementById('gscModalBody').value;
    STATE[modalIdx].shaftBall = document.getElementById('gscModalShaftBall').checked;
    STATE[modalIdx].bodyBall = document.getElementById('gscModalBodyBall').checked;
    refreshCard(modalIdx);
    closeModal();
  }

  function setFilter(val){
    var map = { struts: 'gscSection-struts', fittings: 'gscSection-fittings', brackets: 'gscSection-brackets' };
    Object.keys(map).forEach(function(key){
      var el = document.getElementById(map[key]);
      if(!el) return;
      if(val === 'all' || val === key){
        el.classList.remove('gsc-hidden');
      } else {
        el.classList.add('gsc-hidden');
      }
    });
    var clSection = document.getElementById('gscCustomLength');
    if(clSection){
      if(val === 'all' || val === 'struts'){
        clSection.classList.remove('gsc-hidden');
      } else {
        clSection.classList.add('gsc-hidden');
      }
    }
  }

  /* openPreorderModal / closePreorderModal / submitPreorder were removed on
     14/09/2026 with the rest of pre-ordering. They are not commented out on
     purpose: the markup they drove is gone from both copies of this page, so
     leaving them would have been three functions that throw on a null
     element the first time anyone wired a button back up. */

  function openBulkModal(idx, requestedQty){
    bulkIdx = idx;
    var sz = STRUT_SIZES[idx];
    document.getElementById('gscBulkTitle').textContent = 'Request a Bulk Order - ' + sz.diam + 'mm × ' + sz.len + 'mm';
    document.getElementById('gscBulkContext').textContent = sz.diam + 'mm × ' + sz.len + 'mm gas strut · ' + sz.qty + ' currently in stock';
    document.getElementById('gscBulkQty').value = requestedQty || Math.max(sz.qty + 1, 20);
    document.getElementById('gscBulkError').classList.remove('show');
    document.getElementById('gscBulkMsg').classList.remove('show');
    document.getElementById('gscBulkOverlay').classList.add('show');
  }

  function closeBulkModal(){
    document.getElementById('gscBulkOverlay').classList.remove('show');
    bulkIdx = null;
  }

  function submitBulkOrder(){
    if(bulkIdx === null) return;
    var sz = STRUT_SIZES[bulkIdx];
    var errorEl = document.getElementById('gscBulkError');
    var msgEl = document.getElementById('gscBulkMsg');
    errorEl.classList.remove('show');
    var name = document.getElementById('gscBulkName').value.trim();
    var email = document.getElementById('gscBulkEmail').value.trim();
    var qty = parseInt(document.getElementById('gscBulkQty').value, 10) || 0;
    var notes = document.getElementById('gscBulkNotes').value.trim();
    if(!name){
      errorEl.textContent = 'Please enter your name.';
      errorEl.classList.add('show');
      return;
    }
    if(!email || email.indexOf('@') === -1){
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.classList.add('show');
      return;
    }
    if(qty < 1){
      errorEl.textContent = 'Please enter a quantity of at least 1.';
      errorEl.classList.add('show');
      return;
    }
    var btn = document.getElementById('gscBulkSubmitBtn');
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Sending…';
    var formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('quantity', String(qty));
    formData.append('product', sz.diam + 'mm x ' + sz.len + 'mm gas strut (currently ' + sz.qty + ' in stock)');
    /* Struxa: the request used to arrive with a size and nothing else, so the
       exact strut the customer had configured - force, both end fittings, ball
       studs - was lost and had to be asked for again. Send the build code and
       a plain-English spec alongside it. */
    var bst = STATE[bulkIdx] || {};
    var bcode = buildProductCode(sz.diam, sz.len, bst.force, bst.shaftFit, bst.shaftBall, bst.bodyFit, bst.bodyBall);
    var fitName = function(id, ball){
      var f = FIT_MAP[id];
      if(!f) return '?';
      return f.name + (ball && f.studCompatible ? ' + ball stud' : '');
    };
    formData.append('strut_code', bcode || 'not resolvable');
    formData.append('build', sz.diam + 'mm x ' + sz.len + 'mm · ' + (bst.force || '?') + 'N · shaft end: ' +
      fitName(bst.shaftFit, bst.shaftBall) + ' · body end: ' + fitName(bst.bodyFit, bst.bodyBall));
    formData.append('notes', notes);
    formData.append('_subject', 'Struxa - Bulk Order Request' + (bcode ? ' - ' + bcode : ''));
    fetch('https://formspree.io/f/maqgbndr', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).then(function(res){
      if(res.ok){
        msgEl.classList.add('show');
        setTimeout(closeBulkModal, 1800);
      } else {
        errorEl.textContent = 'Something went wrong sending your request. Please email info@struxamotion.com directly.';
        errorEl.classList.add('show');
      }
    }).catch(function(){
      errorEl.textContent = 'Something went wrong sending your request. Please email info@struxamotion.com directly.';
      errorEl.classList.add('show');
    }).finally(function(){
      btn.disabled = false;
      btn.textContent = origText;
    });
  }

  window.GSC = {
    openModal: openModal,
    closeModal: closeModal,
    applyModal: applyModal,
    setFilter: setFilter,
    goToCustomLength: goToCustomLength,
    openBulkModal: openBulkModal,
    closeBulkModal: closeBulkModal,
    submitBulkOrder: submitBulkOrder
  };

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ buildAll(); applyCodeParam(); });
  } else {
    buildAll();
    applyCodeParam();
  }
})();

/* See the note beside the "View cart" message above. */
document.addEventListener('click', function (ev) {
  var a = ev.target && ev.target.closest ? ev.target.closest('[data-gsc-viewcart]') : null;
  if (!a) return;
  if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.open !== 'function') return;
  ev.preventDefault();
  drawer.open(a);
});
